import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IQrGenerateCodeResponse } from '../../../entity/interface/iQrCodes';

export interface IQrGenerateCodeUseCase {
    execute(
        type: string,
        username: string | undefined,
        timestamp: number,
        payload: string | { [key: string]: any },
        language: string
    ): Promise<IQrGenerateCodeResponse['data']>;
}

export class QrGenerateCodeUseCase implements IQrGenerateCodeUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        type: string,
        username: string | undefined,
        timestamp: number,
        payload: string | { [key: string]: any },
        language: string
    ): Promise<IQrGenerateCodeResponse['data']> {
        const response = await this.userRepo.qrGenerateCode(type, username, timestamp, payload, language);
        return response.data;
    }
}
